<template>
  <div class="wapper">
    <div class="header">
      <div class="headerContent">{{ name }}</div>
      <slot name="back"></slot>
    </div>
    <div class="main">
      <slot name="content"></slot>
    </div>
    <div class="bottom-left" />
    <div class="bottom-right" />
  </div>
</template>

<script>
export default {
  name: 'resourceBox',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="less">
.wapper {
  width: 100%;
  height: 100%;
  background: #ffffff;
  background: linear-gradient(180deg, rgba(14, 40, 73, 0.2) 0%, rgba(32, 73, 130, 0) 100%);
  border-bottom: 1px solid;
  border-image: linear-gradient(to right,rgba(32, 73, 130, 0), rgba(47, 241, 255, 1), rgba(32, 73, 130, 0)) 1;
  position: relative;
  .header {
    height: 40px;
    width: 100%;
    background: url('~@/assets/recycling/echartsMap/resourceHeader.svg') no-repeat;
    background-size: contain;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .headerContent {
      height: 100%;
      font-size: 18px;
      display: flex;
      align-items: center;
      padding-left: 45px;
      font-weight: 900;
      color: #ffffff;
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 40px);
  }
  .bottom-left {
    width: 8px;
    height: 8px;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #00eeff;
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%);
  }
  .bottom-right {
    width: 8px;
    height: 8px;
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: #00eeff;
    clip-path: polygon(100% 100%, 0% 100%, 100% 0%);
  }
}
</style>
